// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-interface {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.messages-container {
  flex: 1 1;
  padding: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.welcome-message {
  text-align: center;
  padding: 2rem;
  color: #7f8c8d;
}

.message {
  display: flex;
}

.message.user {
  justify-content: flex-end;
}

.message.assistant {
  justify-content: flex-start;
}

.message-bubble {
  max-width: 70%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  position: relative;
}

.message.user .message-bubble {
  background-color: #3498db;
  color: white;
}

.message.assistant .message-bubble {
  background-color: #f1f8e9;
  color: #333;
}

.message-bubble.loading {
  background-color: #f8f9fa;
  color: #7f8c8d;
}

.message-label {
  font-size: 0.75rem;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
  opacity: 0.8;
}

.message-text {
  margin: 0;
  line-height: 1.4;
  white-space: pre-wrap;
}

.message-sources {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.75rem;
  opacity: 0.8;
}

.sources-info {
  color: #2e7d32;
  font-style: italic;
}

.sources-none {
  color: #7f8c8d;
  font-style: italic;
}

.play-audio-btn {
  margin-top: 0.5rem;
  padding: 0.25rem 0.5rem;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;
}

.play-audio-btn:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.2);
}

.play-audio-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.typing-indicator {
  display: inline-block;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.input-container {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid #eee;
  align-items: flex-end;
}

.message-input {
  flex: 1 1;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 0.875rem;
}

.message-input:focus {
  outline: none;
  border-color: #3498db;
}

.message-input:disabled {
  background-color: #f5f5f5;
}

.send-btn {
  padding: 0.75rem 1.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.send-btn:hover:not(:disabled) {
  background-color: #2980b9;
}

.send-btn:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.end-session-btn {
  padding: 0.75rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.end-session-btn:hover:not(:disabled) {
  background-color: #c0392b;
}

.end-session-btn:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .messages-container {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .message-bubble {
    max-width: 85%;
    padding: 0.6rem 0.85rem;
  }

  .message-label {
    font-size: 0.7rem;
  }

  .message-text {
    font-size: 0.9rem;
  }

  .message-sources {
    font-size: 0.7rem;
  }

  .input-container {
    flex-wrap: wrap;
    padding: 0.75rem;
    gap: 0.4rem;
  }

  .message-input {
    font-size: 0.85rem;
    padding: 0.6rem;
    min-height: 40px;
  }

  .send-btn, .end-session-btn {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }

  .play-audio-btn {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
  }
}

@media (max-width: 480px) {
  .message-bubble {
    max-width: 90%;
    padding: 0.5rem 0.75rem;
  }

  .message-text {
    font-size: 0.85rem;
    line-height: 1.3;
  }

  .input-container {
    padding: 0.5rem;
  }

  .message-input {
    width: 100%;
    flex-basis: 100%;
    margin-bottom: 0.4rem;
    font-size: 0.85rem;
    padding: 0.5rem;
  }

  .send-btn {
    flex: 1 1;
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }

  .end-session-btn {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }

  .play-audio-btn {
    font-size: 0.75rem;
    padding: 0.15rem 0.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatInterface.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF","sourcesContent":[".chat-interface {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.messages-container {\n  flex: 1;\n  padding: 1rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.welcome-message {\n  text-align: center;\n  padding: 2rem;\n  color: #7f8c8d;\n}\n\n.message {\n  display: flex;\n}\n\n.message.user {\n  justify-content: flex-end;\n}\n\n.message.assistant {\n  justify-content: flex-start;\n}\n\n.message-bubble {\n  max-width: 70%;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  position: relative;\n}\n\n.message.user .message-bubble {\n  background-color: #3498db;\n  color: white;\n}\n\n.message.assistant .message-bubble {\n  background-color: #f1f8e9;\n  color: #333;\n}\n\n.message-bubble.loading {\n  background-color: #f8f9fa;\n  color: #7f8c8d;\n}\n\n.message-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.25rem;\n  opacity: 0.8;\n}\n\n.message-text {\n  margin: 0;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n.message-sources {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  font-size: 0.75rem;\n  opacity: 0.8;\n}\n\n.sources-info {\n  color: #2e7d32;\n  font-style: italic;\n}\n\n.sources-none {\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n.play-audio-btn {\n  margin-top: 0.5rem;\n  padding: 0.25rem 0.5rem;\n  background-color: rgba(0, 0, 0, 0.1);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background-color 0.2s;\n}\n\n.play-audio-btn:hover:not(:disabled) {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.play-audio-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.typing-indicator {\n  display: inline-block;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.input-container {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem;\n  border-top: 1px solid #eee;\n  align-items: flex-end;\n}\n\n.message-input {\n  flex: 1;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  resize: none;\n  font-family: inherit;\n  font-size: 0.875rem;\n}\n\n.message-input:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.message-input:disabled {\n  background-color: #f5f5f5;\n}\n\n.send-btn {\n  padding: 0.75rem 1.5rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.send-btn:hover:not(:disabled) {\n  background-color: #2980b9;\n}\n\n.send-btn:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.end-session-btn {\n  padding: 0.75rem 1rem;\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.end-session-btn:hover:not(:disabled) {\n  background-color: #c0392b;\n}\n\n.end-session-btn:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .messages-container {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .message-bubble {\n    max-width: 85%;\n    padding: 0.6rem 0.85rem;\n  }\n\n  .message-label {\n    font-size: 0.7rem;\n  }\n\n  .message-text {\n    font-size: 0.9rem;\n  }\n\n  .message-sources {\n    font-size: 0.7rem;\n  }\n\n  .input-container {\n    flex-wrap: wrap;\n    padding: 0.75rem;\n    gap: 0.4rem;\n  }\n\n  .message-input {\n    font-size: 0.85rem;\n    padding: 0.6rem;\n    min-height: 40px;\n  }\n\n  .send-btn, .end-session-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .play-audio-btn {\n    font-size: 0.8rem;\n    padding: 0.2rem 0.4rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .message-bubble {\n    max-width: 90%;\n    padding: 0.5rem 0.75rem;\n  }\n\n  .message-text {\n    font-size: 0.85rem;\n    line-height: 1.3;\n  }\n\n  .input-container {\n    padding: 0.5rem;\n  }\n\n  .message-input {\n    width: 100%;\n    flex-basis: 100%;\n    margin-bottom: 0.4rem;\n    font-size: 0.85rem;\n    padding: 0.5rem;\n  }\n\n  .send-btn {\n    flex: 1;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .end-session-btn {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .play-audio-btn {\n    font-size: 0.75rem;\n    padding: 0.15rem 0.35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
